
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { GatewayApi } from "./api";
import GatewayInfo from "./GatewayInfo";

interface GatewayInfoWidgetProps {
  id: string;
  header: string;
}

const GatewayWidget = (props: GatewayInfoWidgetProps) => {
  const [machineGatewayInfo, updateMachineGatewayInfo] = useState(null);
  const [gatewayInfoLoading, updateLoadingGatewayInfo] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (globalParams.mainMachineSerialNo != null) {
      updateLoadingGatewayInfo(true);
      getMachineGatewayInfo(globalParams.mainMachineSerialNo, signal);
    }

    return () => controller.abort();
  }, [globalParams.mainMachineSerialNo]);

  const getMachineGatewayInfo = (machineSerial, signal) => {
    let params: any = { machineSerial };
    GatewayApi.getMachineGatewayInfo(params, signal)
      .then((response: any) => {
        updateMachineGatewayInfo(response);
        updateLoadingGatewayInfo(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingGatewayInfo(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (gatewayInfoLoading) {
    return <Spinner text="remote gateway information" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  if (machineGatewayInfo == null || machineGatewayInfo.length == 0) {
    return <div>No Remote Gateway found.</div>;
  }
  return (
    <>
      <GatewayInfo gateways={machineGatewayInfo} />
    </>
  );
};

export default GatewayWidget;
